import { render, staticRenderFns } from "./ptspkota.vue?vue&type=template&id=ec041648"
import script from "./ptspkota.vue?vue&type=script&lang=js"
export * from "./ptspkota.vue?vue&type=script&lang=js"
import style0 from "./ptspkota.vue?vue&type=style&index=0&id=ec041648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports